(() => {
  const storageKey = 'wishlistItem';
  const changeEvent = 'jvan:wishlist-change';

  const readHandles = () => {
    try {
      const value = JSON.parse(localStorage.getItem(storageKey) || '[]');
      return Array.isArray(value) ? [...new Set(value.filter((handle) => typeof handle === 'string' && handle))] : [];
    } catch (error) {
      return [];
    }
  };

  const writeHandles = (handles) => {
    const normalizedHandles = [...new Set(handles.filter(Boolean))];
    localStorage.setItem(storageKey, JSON.stringify(normalizedHandles));
    window.dispatchEvent(new CustomEvent(changeEvent, { detail: { handles: normalizedHandles } }));
    return normalizedHandles;
  };

  const renderWishlistLinks = (handles) => {
    const count = handles.length;

    document.querySelectorAll('[data-jvan-wishlist-link]').forEach((link) => {
      link.toggleAttribute('data-has-items', count > 0);
      link.setAttribute('aria-label', count > 0 ? `Wish list (${count} saved)` : 'Wish list');
    });
  };

  class JvanWishlistButton extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;

      this.dataset.ready = 'true';
      this.button = this.querySelector('button');
      this.handle = this.dataset.productHandle;
      this.onClick = this.onClick.bind(this);
      this.onChange = this.onChange.bind(this);
      this.onStorage = this.onStorage.bind(this);

      this.button?.addEventListener('click', this.onClick);
      window.addEventListener(changeEvent, this.onChange);
      window.addEventListener('storage', this.onStorage);
      this.render(readHandles());
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.onClick);
      window.removeEventListener(changeEvent, this.onChange);
      window.removeEventListener('storage', this.onStorage);
      delete this.dataset.ready;
    }

    onClick() {
      if (!this.handle || !this.button) return;

      try {
        const handles = readHandles();
        const nextHandles = handles.includes(this.handle)
          ? handles.filter((handle) => handle !== this.handle)
          : [...handles, this.handle];
        writeHandles(nextHandles);
      } catch (error) {
        this.button.setAttribute('aria-label', 'Wish list could not be updated');
      }
    }

    onChange(event) {
      this.render(event.detail?.handles || readHandles());
    }

    onStorage(event) {
      if (event.key === storageKey) this.render(readHandles());
    }

    render(handles) {
      if (!this.button || !this.handle) return;

      const selected = handles.includes(this.handle);
      this.button.setAttribute('aria-pressed', String(selected));
      this.button.setAttribute('aria-label', selected ? this.dataset.removeLabel : this.dataset.addLabel);
      this.toggleAttribute('selected', selected);
    }
  }

  class JvanPurchaseActions extends HTMLElement {
    connectedCallback() {
      const primaryRow = this.querySelector('[data-jvan-purchase-primary]');
      const quantityFormId = this.dataset.quantityFormId;
      const quantityForm = quantityFormId ? document.getElementById(quantityFormId) : null;

      if (!primaryRow || !quantityForm) return;

      primaryRow.prepend(quantityForm);
      primaryRow.classList.add('jvan-purchase-actions__primary--has-quantity');
    }
  }

  if (!customElements.get('jvan-wishlist-button')) {
    customElements.define('jvan-wishlist-button', JvanWishlistButton);
  }

  if (!customElements.get('jvan-purchase-actions')) {
    customElements.define('jvan-purchase-actions', JvanPurchaseActions);
  }

  window.addEventListener(changeEvent, (event) => {
    renderWishlistLinks(event.detail?.handles || readHandles());
  });

  window.addEventListener('storage', (event) => {
    if (event.key === storageKey) renderWishlistLinks(readHandles());
  });

  renderWishlistLinks(readHandles());
})();
